import { render } from "./FacebookFollowers.vue?vue&type=template&id=b619033c&scoped=true&ts=true"
import script from "./FacebookFollowers.vue?vue&type=script&lang=ts"
export * from "./FacebookFollowers.vue?vue&type=script&lang=ts"

import "./FacebookFollowers.vue?vue&type=style&index=0&id=b619033c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b619033c"]])

export default __exports__